const dataAccessMethods = require('../../../dataAccessMethods');
const Blockly = require('blockly');
const { config } = require('@sstdev/lib_metadata-config');
const DelegatingMdcBlockGroup = require('../_DelegatingMdcBlockGroup');
const hNodeTypes = require('./types');

class WorkflowPane extends DelegatingMdcBlockGroup {
    constructor(hNodeTypeGroup, categorySpec, color, subset = '') {
        super(hNodeTypeGroup, categorySpec, color, subset);
        super.types = hNodeTypes;
    }

    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        if (hNodeType === 'WorkflowActionPane') {
            let dropDownAction = blocklyBlock.getFieldValue('action');
            code.workflowAction = dropDownAction;

            let dropdownNamespace = blocklyBlock.getFieldValue('namespace');
            let dropdownRelation = blocklyBlock.getFieldValue('relation');
            code.foreignNamespace = dropdownNamespace;
            code.foreignRelation = dropdownRelation;
            code.propertyName = dropDownAction.includes('_')
                ? dropDownAction
                : `${dropDownAction}_${dropdownNamespace}_${dropdownRelation}`;
        }
        if (hNodeType === 'WorkflowActionList') {
            code.propertyName = 'actions';
        } else if (hNodeType === 'WorkflowCriteriaPane') {
            code.propertyName = 'criteria';
        }

        return JSON.stringify(code);
    }

    addToBlocksCustom(color, blocklyBlock, hNodeType) {
        if (hNodeType === 'WorkflowCriteriaPane') {
            blocklyBlock
                .appendStatementInput('children')
                .setCheck(['workflowCriteriaElement'])
                .appendField('Criteria:', 'childrenField');
        } else if (hNodeType === 'WorkflowActionList') {
            blocklyBlock
                .appendStatementInput('children')
                .setCheck(['workflowPane'])
                .appendField('Available Actions:', 'childrenField');
        } else if (hNodeType === 'WorkflowActionPane') {
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Action:')
                .appendField(new Blockly.FieldDropdown(config.workflowActions), 'action');

            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Optional Namespace:')
                .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getNamespaces(true)), 'namespace');
            let blockId = blocklyBlock.id;
            let workspace = blocklyBlock.workspace;
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Optional Relation:')
                .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId, true)), 'relation');
            blocklyBlock
                .appendStatementInput('children')
                .setCheck(['formElement', 'dataView', 'layout'])
                .appendField('Form Elements:', 'childrenField');
        }
    }
}

module.exports = WorkflowPane;
